export const RICH_TEXT_EXTERNAL_UPDATE_TAG = "rich-text-external-update";

export function isRichTextExternalUpdate(tags: ReadonlySet<string>): boolean {
  return tags.has(RICH_TEXT_EXTERNAL_UPDATE_TAG);
}

/**
 * Descriptions written before the rich text editor existed are stored as plain
 * text; everything the editor saves is HTML (always starts with a tag).
 */
export function isRichTextHtml(value: string): boolean {
  return value.trimStart().startsWith("<");
}

/**
 * The text of a rich text value on a single line, for previews and anywhere
 * else that has no room to render markup. Parsing never runs scripts or loads
 * anything: only the parsed document's text is read.
 */
export function richTextToPlainText(value: string): string {
  if (!isRichTextHtml(value)) return value.trim();

  const { body } = new DOMParser().parseFromString(value, "text/html");
  return (body.textContent ?? "").replace(/\s+/g, " ").trim();
}
